import styled from 'styled-components'

import addPx from 'utils/addPx'

const Flex = styled.div`
	display: flex;
	flex-flow: ${p => p.flow || 'column nowrap'};
	align-items: ${p => p.align || 'stretch'};
	justify-content: ${p => p.justify || 'space-between'};

	gap: ${p => addPx(p.gap) || 0};

	@supports (-webkit-touch-callout: none) and (not (translate: none)) {
		> :not(:last-child) {
			${p =>
				p.direction === 'column' ||
				(p.flow?.startsWith('column') &&
					`
        margin-bottom: ${p => addPx(p.gap) || 0};
      `)}

			${p =>
				!p.direction ||
				p.direction === 'row' ||
				(p.flow?.startsWith('row') &&
					`
        margin-right: ${p => addPx(p.gap) || 0};
      `)}
		}
	}

	${p => p.direction && `flex-direction: ${p.direction}`}

	${p => p.theme.above('md')`
    flex-flow: ${p => p.flow || 'row nowrap'};
    ${p => p.direction && `flex-direction: ${p.direction}`}
  `}
`

export default Flex
